var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55556 13.3333H8.88889V8H3.55556L3.55556 13.3333ZM5.33333 9.77778H7.11111V11.5556H5.33333V9.77778Z",
    fill: "#39414A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 1.77778L10.6667 1.77778V0H12.4444V1.77778H16V16H0V1.77778L3.55556 1.77778V0H5.33333V1.77778ZM1.77778 3.55555L14.2222 3.55556V5.33333L1.77778 5.33333L1.77778 3.55555ZM1.77778 7.11111L1.77778 14.2222H14.2222V7.11111L1.77778 7.11111Z",
    fill: "#39414A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsIconCalendar);
export default __webpack_public_path__ + "static/media/os-icon-calendar.d9e38a62d16c2ed3a3c961295c20c95d.svg";
export { ForwardRef as ReactComponent };